// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"9452":"team-driving.module","32466":"public.module","34119":"public-cards-application.module","51849":"semantic-css","74398":"driver-safety.module","85385":"device.module","91447":"app-fleet-view.module","93541":"loadboard.module"}[chunkId] || chunkId) + ".css";
};